import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.5 10.7212L5.5575 11.7787L9 8.34375L12.4425 11.7787L13.5 10.7212L9 6.22125L4.5 10.7212Z",
		fill: "currentColor"
	})
});
export default SvgUp;
